<div class="page-layout">
  <mat-card class="fleets-card rounded" appearance="outlined">
    <mat-toolbar>
      <span>Manage Fleets</span>
      <span class="spacer"></span>
      <button mat-raised-button color="primary" type="button"
              (click)="onCreateFleet()">
        <mat-icon>add</mat-icon>
        Add
      </button>
    </mat-toolbar>
    <mat-list>
      <mat-list-item *ngFor="let fleet of fleets"
                     [class.selected-list-item]="fleet === selectedFleet"
                     (click)="selectFleet(fleet)"
                     class="list-item rounded">
        <span matListItemTitle>{{ fleet.name }}</span>

        <!-- Description (Sub-line) -->
        <span matListItemLine>{{ fleet.description }}</span>

        <!-- Action Menu (Meta section) -->
        <div matListItemMeta>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Action menu" style="margin-top: 8px;" *ngIf="fleet === selectedFleet">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onEditFleet()">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="onDeleteFleet()">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card>
  <mat-card class="main-card rounded" appearance="outlined">
    <mat-toolbar *ngIf="selectedFleet">
      <span>{{ selectedFleet?.name || 'Fleet' }}</span>
      <span class="spacer"></span>
      <button mat-stroked-button type="button" (click)="toggleMarkerMode()"
              [disabled]="!selectedImage"
              *ngIf="showMarkers">
        <mat-icon>place</mat-icon>
        {{ addMarkerMode ? 'Stop Marking' : 'Add Marker' }}T
      </button>
      <button mat-stroked-button color="primary" type="button"
              (click)="saveMarkers()" [disabled]="!selectedImage" *ngIf="showMarkers">
        <mat-icon>save</mat-icon>
        Save Markers
      </button>
    </mat-toolbar>
    <div class="main-stage" *ngIf="selectedImage; else emptyState">
      <div class="image-surface" #imageSurface
           (click)="addMarkerOnImage($event)">
        <img class="main-image"
             [src]="getImageUrl(selectedImage.fileName)"
             [alt]="selectedImage.name" />
        <div *ngFor="let marker of selectedImage.deviceMarkers"
             class="marker-box"
             cdkDrag
             [style.left]="leftPercent(marker)"
             [style.top]="topPercent(marker)"
             [matTooltip]="marker.name || 'Marker'"
             (cdkDragEnded)="markerDropped($event, marker)"
             (click)="$event.stopPropagation()"></div>
      </div>
      <div class="main-footer">
        <div>
          <div class="file-name">{{ selectedImage.fileName }}</div>
          <div class="meta-row">
            {{ selectedImage.description }}
          </div>
        </div>
        <button mat-button color="warn" type="button"
                (click)="deleteSelectedImage()">
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      </div>
      <div class="markers-panel" *ngIf="showMarkers && selectedImage.deviceMarkers.length > 0">
        <div class="marker-row" *ngFor="let marker of selectedImage.deviceMarkers">
          <span>{{ marker.name || marker.id }}</span>
          <button mat-icon-button color="warn" type="button"
                  (click)="removeMarker(marker.id)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <ng-template #emptyState>
      <div class="empty-state">
        <mat-icon>photo_library</mat-icon>
        <div>Select a fleet and upload images.</div>
      </div>
    </ng-template>
    <div class="busy-row" *ngIf="isBusy || errorMessage">
      <mat-progress-spinner *ngIf="isBusy" diameter="24" mode="indeterminate">
        </
        mat-progress-spinner>
        <span class="error-text" *ngIf="errorMessage">{{ errorMessage }}</span>
    </div>
  </mat-card>
  <mat-card class="thumbs-card rounded" appearance="outlined">
    <mat-toolbar *ngIf="selectedFleet">
      Gallery
      <span class="spacer"></span>
      <input #fileInput
             type="file"
             accept="image/*"
             (change)="onFileSelected($event)"
             style="display: none" />

      <button mat-raised-button
              color="primary"
              type="button"
              (click)="fileInput.click()"
              [disabled]="!selectedFleet">
        <mat-icon>upload</mat-icon>
        Upload
      </button>
    </mat-toolbar>
    <div class="thumbs-list" cdkDropList
         (cdkDropListDropped)="dropThumbnail($event)">
      <mat-card class="thumb-card"
                *ngFor="let image of selectedFleet?.fleetImages || []"
                cdkDrag
                [class.selected-thumb]="image.fleetImageId === selectedImage?.fleetImageId"
                (click)="selectImage(image)">
        <img class="thumb-image"
             [src]="getImageUrl(image.fileName)"
             [alt]="image.name" />
        <div class="thumb-caption">{{ image.name }}</div>
      </mat-card>
    </div>
  </mat-card>
  <p-dialog header="Create or Edit the Fleet"
            [(visible)]="displayFleetCreateOrEditDialog"
            [style]="{ width: '30vw' }"
            [draggable]="false"
            [resizable]="false"
            class="dialog">

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Name</mat-label>
      <input matInput name="fleetName" required [(ngModel)]="fleetName">
      <mat-error>This field is required</mat-error>
    </mat-form-field>

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Description</mat-label>
      <input matInput name="fleetDescription" [(ngModel)]="fleetDescription">
    </mat-form-field>

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Fleet Owner</mat-label>
      <input matInput name="fleetOwner" [(ngModel)]="fleetOwner">
    </mat-form-field>

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Last Assessed</mat-label>
      <input
        matInput
        [matDatepicker]="picker1"
        [(ngModel)]="lastAssessed"
        name="startDate"
        required
      />

      <mat-datepicker-toggle
        matSuffix
        [for]="picker1"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Next Assessment</mat-label>
      <input
        matInput
        [matDatepicker]="picker2"
        [(ngModel)]="nextAssessment"
        name="startDate"
        required
      />

      <mat-datepicker-toggle
        matSuffix
        [for]="picker2"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>



    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Support Contact</mat-label>
      <input matInput name="supportContact" [(ngModel)]="supportContact">
    </mat-form-field>

    <mat-form-field class="input-section" style="width: 92%; margin: 0 15px;">
      <mat-label>Maintenance</mat-label>
      <input matInput name="maintenance" [(ngModel)]="maintenance">
    </mat-form-field>

    <ng-template pTemplate="footer">
      <alert></alert>

      <div class="save-button"
           style="display: flex; gap: 10px; justify-content: flex-start; align-items: center; margin-bottom: 15px;">

        <button mat-raised-button type="button" (click)="saveFleet()">
          Save
        </button>

        <button mat-raised-button
                type="button"
                class="cancel-button"
                (click)="closeOpenFleetCreateOrEditDialog()">
          Cancel
        </button>

      </div>
    </ng-template>
  </p-dialog>
</div>
